"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("..");
var geometry_1 = require("../geometry");
var component_1 = require("./component");
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasFlexibleSize = true;
        _this.hasFixedSize = false;
        return _this;
    }
    Layout.prototype.defaultOptions = function () {
        return __assign(__assign({}, _super.prototype.defaultOptions.call(this)), { _direction: "vertical", _gap: 0 });
    };
    Layout.prototype._append = function (element, isGroup) {
        if (isGroup === void 0) { isGroup = false; }
        return _super.prototype.appendT.call(this, LayoutItem).options({
            _width: geometry_1.GeometryValue.fullSize, _height: geometry_1.GeometryValue.fullSize,
        })._append(element);
    };
    Layout.prototype.layoutSubTree = function () {
        _super.prototype.layoutSubTree.call(this);
        this.layout(false);
    };
    Layout.prototype.preRender = function () {
        var isHorizontal = this.getOption("_direction") === "horizontal";
        this.markAllDirty([isHorizontal ? "_width" : "_height"]);
        _super.prototype.preRender.call(this);
    };
    Layout.prototype.postRender = function () {
        _super.prototype.postRender.call(this);
    };
    Layout.prototype.layout = function (force) {
        var _a;
        var _this = this;
        if (force === void 0) { force = true; }
        var counter = 0;
        var isHorizontal = this.getOption("_direction") === "horizontal";
        var gap = this.getOption("_gap");
        this.elements.forEach(function (item, index) {
            var origItem = item.elements[0];
            if (!origItem.getOption("_display")) {
                return;
            }
            var size = { x: 0, y: 0, width: 0, height: 0 };
            var getter = origItem.getOption("_dynamicSizeGetter", null, null, null, true);
            if (typeof getter === "function") {
                size = getter.call(origItem);
            }
            else if (origItem.computedSize) {
                size = force ? origItem.computedSize(null, true) : origItem.computedSize();
            }
            var currentGap = index === _this.elements.length - 1 ? 0 : gap;
            if (isHorizontal) {
                item.dom.attr("transform", __1.tool.translate(counter, 0));
                counter += size.x + size.width + currentGap;
            }
            else {
                item.dom.attr("transform", __1.tool.translate(0, counter));
                counter += size.y + size.height + currentGap;
            }
        });
        this.setDynamicSize((_a = {}, _a[isHorizontal ? "width" : "height"] = counter, _a));
    };
    return Layout;
}(component_1.Component));
exports.Layout = Layout;
var LayoutItem = /** @class */ (function (_super) {
    __extends(LayoutItem, _super);
    function LayoutItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LayoutItem.prototype.findFixedParent = function () {
        return this.parent.findFixedParent();
    };
    return LayoutItem;
}(component_1.Component));
//# sourceMappingURL=layout.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/layout.js
// module id = 1171
// module chunks = 0 1